<template>
    <div>
        <div class="payType" :style="{border:(selected == true?'#ed6c00 solid 1px':'none')}">
            <img :src="imagePath" :width="imgWidth" height="30px"/>
            <span>{{label}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        name: "PaymentType",
        props: {
            label: String,
            imgWidth: {
                default:"30px",
            },
            imagePath:{
                default:"",
            },
            selected: {
                default: false,
            }
        },
        data: function () {
            return {
                labelValue: '66',
            };
        }
    }
</script>

<style lang="scss" scoped>
    .payType{
        display: flex;
        flex-direction: row;
        align-items: center;
        border: #ed6c00 solid 1px;
        padding:10px;
        span{
            margin-left: 15px;
        }
        // img{
        //     width:25px;
        // }
    }
    
</style>